import React, { useMemo, useState } from "react";
import pageStyles from "./UpdateUser.module.css";

interface UserItem {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    login: string;
    email: string;
}

interface PositionUsersAccordionProps {
    position: string;
    users: UserItem[];
    selectedUserId: string;
    searchQuery: string;
    onChange: (event: any) => void;
}

const PositionUsersAccordion = ({
    position,
    users,
    selectedUserId,
    searchQuery,
    onChange,
}: PositionUsersAccordionProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const filtered = useMemo(() => {
        const q = searchQuery.trim().toLowerCase();
        if (!q) return users;

        return users.filter((u) => {
            const full =
                `${u.lastName} ${u.firstName} ${u.middleName} ${u.login} ${u.email}`.toLowerCase();
            return full.includes(q);
        });
    }, [users, searchQuery]);

    const toggleUser = (id: string) => {
        const idStr = id.toString();
        const nextValue = selectedUserId === idStr ? "" : idStr;
        onChange({ target: { value: nextValue } });
    };

    if (filtered.length === 0) {
        return null;
    }

    return (
        <div className={pageStyles.accordionCard}>
            <div
                className={pageStyles.accordionHeaderStatic}
                onClick={() => setIsOpen((prev) => !prev)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setIsOpen((prev) => !prev);
                    }
                }}
            >
                <div className={pageStyles.accordionHeaderText}>
                    <div className={pageStyles.accordionTitle}>{position}</div>
                    <div className={pageStyles.accordionCount}>
                        {filtered.length} пользователей
                    </div>
                </div>

                <div className={`${pageStyles.chevron} ${isOpen ? pageStyles.chevronOpen : ""}`}>
                    ▼
                </div>
            </div>

            {isOpen && (
                <div className={pageStyles.accordionBody}>
                    <div className={pageStyles.userListContainer}>
                        {filtered.map((u) => {
                            const idStr = u.id.toString();
                            const checked = selectedUserId === idStr;

                            return (
                                <label
                                    key={u.id}
                                    className={`${pageStyles.userListItem} ${
                                        checked ? pageStyles.userListItemChecked : ""
                                    }`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleUser(u.id);
                                    }}
                                >
                                    <div className={pageStyles.userText}>
                                        <div className={pageStyles.userPrimary}>
                                            {u.lastName} {u.firstName} {u.middleName}
                                        </div>
                                        <div className={pageStyles.userSecondary}>
                                            {u.login} • {u.email}
                                        </div>
                                    </div>
                                </label>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PositionUsersAccordion;
